import { useQuery } from "@tanstack/react-query"
import { api } from "@/services/api"
import extractISODate from "@/modules/calendar/utils/extract-iso-date"
import getDailyCalendarEvents from "../utils/get-daily-calendar-events"
import { endOfDay, formatISO, startOfDay } from "date-fns"

export default function useGetDailyCalendar() {
  const query = useQuery({
    queryKey: ["get-daily-calendar"],
    queryFn: async () => {
      const today = new Date()

      const eventsParams = {
        startDate: extractISODate(today),
        endDate: extractISODate(today),
      }

      const activitiesParams = {
        startDate: formatISO(startOfDay(today)),
        endDate: formatISO(endOfDay(today)),
      }

      const events = (await api.cronos.user.events.getAll(eventsParams)).data.description
      const activities = (await api.cronos.activities.get(activitiesParams)).data.description

      const filteredActivities = activities.filter((activity) => {
        const isPendingOrFailed = activity.status === "pending" || activity.status === "failed"
        return isPendingOrFailed
      })

      const dailyCalendarEvents = getDailyCalendarEvents(events, filteredActivities)
      return dailyCalendarEvents
    },
    refetchOnWindowFocus: false,
  })

  return query
}
